import { render, staticRenderFns } from "./DistributeTacticModal.vue?vue&type=template&id=7cd6a464"
import script from "./DistributeTacticModal.vue?vue&type=script&lang=ts"
export * from "./DistributeTacticModal.vue?vue&type=script&lang=ts"
import style0 from "./DistributeTacticModal.vue?vue&type=style&index=0&id=7cd6a464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports